import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class DownloadBlobService {
  constructor() {}

  public download(response: HttpResponse<Blob>) {
    if (response != null) {
      const contentDisposition = response.headers.get('content-disposition');
      const filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const windowNavigator = window.navigator as any;

      if (windowNavigator.msSaveOrOpenBlob) {
        windowNavigator.msSaveBlob(response.body, filename);
      } else {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(response.body);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
  }
}
